import { useSelector, useDispatch } from 'react-redux';
import * as Styled from '../../styles/UsuariosAprovados.styles';
import HybridField from '../../../../components/HybridField/HybridField';
import PropTypes from 'prop-types';
import Button from '../../../../components/Button/Button';
import { theme } from '../../../../styles/theme';
import SelectOptions from '../../../../components/SelectOptions/SelectOptions';
import PhoneField from '../../../../components/PhoneField/PhoneField';
import formatCPFCNPJ from '../../../../utils/functions/formatCPFCNPJ';
import { useForm } from 'react-hook-form';
import { cobansFetchAction } from '../../../../store/fetchActions/cobansActions';
import formatAmericanDate from '../../../../utils/functions/formatAmericanDate';
import React, { useState, useEffect } from 'react';

const { mainColor, secondaryColor, rbmBlack, rbmWhite } = theme.colors;
export default function AddressCollum({
  control,
  isEditing,
  cancel,
  handleSubmit,
  errors,
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(cobansFetchAction());
  }, []);

  const { usersData } = useSelector((state) => state.user);
  const { cobansData, loadingCobans } = useSelector((state) => state.cobans);
  const perfisArray = cobansData.filter((val) => val.CPFCNPJ === null);
  const perfis = perfisArray.filter((val) => val.NOME === usersData.NOMECOBAN);

  const {} = useForm({});

  return (
    <>
      {!loadingCobans && (
        <Styled.InformationContainer>
          <h3>SOBRE</h3>
          <Styled.Row>
            <HybridField
              control={control}
              title={'Nome/Razão Social'}
              disabled={true}
              width={'29.306vw'}
              name={'NOME'}
              error={errors.NOME && true}
              value={usersData.NOME}
              margin={'1.389vw 0 0 0'}
            />
            <HybridField
              control={control}
              title={'CPF/CNPJ'}
              disabled={true}
              width={'13.958vw'}
              name={'CPF_CNPJ'}
              error={errors.CPFCNPJ && true}
              value={formatCPFCNPJ(usersData.CPFCNPJ)}
              margin={'1.389vw 0 0 1.389vw'}
            />
            <Styled.Container width={'16.958vw'} margin={'1.389vw 0 0 1.389vw'}>
              <Styled.Title>{'Nascimento/Fundação'}</Styled.Title>
              <Styled.Input
                width={'16.958vw'}
                defaultValue={formatAmericanDate(usersData.NASCIMENTO)}
                disabled={true}
                type="date"
                name={'NASCIMENTO'}
                control={control}
                error={errors.NASCIMENTO && true}
              />
            </Styled.Container>
          </Styled.Row>
          <Styled.Row>
            <HybridField
              control={control}
              title={'E-mail'}
              value={usersData.EMAIL}
              disabled={!isEditing}
              width={'29.306vw'}
              type={'email'}
              name={'EMAIL'}
              error={errors.EMAIL && true}
              margin={'1.389vw 0 0 0'}
            />
            <PhoneField
              control={control}
              title={'Telefone'}
              value={usersData.TELEFONE}
              disabled={!isEditing}
              width={'13.958vw'}
              name={'TELEFONE'}
              error={errors.TELEFONE && true}
              margin={'1.389vw 0 0 1.389vw'}
            />
            <Styled.ContainerCobanProfile>
              <h4>Perfil</h4>
              <SelectOptions
                width={'20.306vw'}
                control={control}
                options={perfisArray}
                initialValue={perfis[0]?.ID}
                initialName={perfis[0]?.NOME}
                margin={'1.189vw 0 0 1.389vw'}
                disabled={!isEditing}
                name={'PERFIL'}
              />
            </Styled.ContainerCobanProfile>
          </Styled.Row>
          <Styled.ButtonContainer>
            {isEditing ? (
              <>
                <Button
                  backgroundColor={rbmWhite}
                  width={'12.153vw'}
                  height={'3.333vw'}
                  hoverBGColor={rbmWhite}
                  hoverColor={rbmBlack}
                  color={rbmBlack}
                  onClick={cancel}
                >
                  <span>CANCELAR</span>
                </Button>
                <Button
                  backgroundColor={secondaryColor}
                  width={'12.153vw'}
                  height={'3.333vw'}
                  hoverBGColor={mainColor}
                  hoverColor={rbmBlack}
                  color={rbmWhite}
                  onClick={handleSubmit}
                >
                  <span>SALVAR</span>
                </Button>
              </>
            ) : null}
          </Styled.ButtonContainer>
        </Styled.InformationContainer>
      )}
    </>
  );
}

AddressCollum.propTypes = {
  control: PropTypes.any,
  isEditing: PropTypes.bool,
  cancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  errors: PropTypes.object,
};
